module.exports = __webpack_public_path__ + "static/media/hourglass.a88121ec.svg";